export const FETCH_RESOURCES = 'FETCH_RESOURCES';
export const FETCH_RESOURCES_BY_GROUP = 'FETCH_RESOURCES_BY_GROUP';
export const FETCH_RESOURCE_CATEGORIES = 'FETCH_RESOURCE_CATEGORIES';
export const CREATE_RESOURCE = 'CREATE_RESOURCE'; 